import ProxyUrls from '@/constants/ProxyUrls';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    brandingData: {},
    socialMedia: {},
    loginImgUrl: null,
    promotionalImgsUrls: [],
    lastUpdate: null,
    privacyPolicy: {},
    termsAndConditions: {},
    contactData: null
  },

  mutations: {
    setBrandingData(state, payload) {
      state.brandingData = payload;
    },

    setSocialMedia(state, payload) {
      state.socialMedia = payload;
    },

    setLoginImgUrl(state, payload) {
      state.loginImgUrl = payload;
    },
    
    setPromotionalImgsUrls(state, payload) {
      state.promotionalImgsUrls = payload;
    },

    setLastUpdate(state, payload) {
      state.lastUpdate = payload;
    },

    setPrivacyPol(state, payload) {
      state.privacyPolicy = payload;
    },

    setTermsAndConditions(state, payload) {
      state.termsAndConditions = payload;
    },

    setContactData(state, payload) {
      state.contactData = payload;
    }
  },

  actions: {
    async getInitialContent({ commit }, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          url: ProxyUrls.initialContent,
          method: 'get',
        });

        if (data && data.httpStatus === 200) {
          commit('setSocialMedia', data.responseData.socialMedia_links);
          commit('setBrandingData', data.responseData.brand_config);
          commit('setLastUpdate', data.responseData.lastUpdate);
          commit('setLoginImgUrl', data.responseData.loginImgUrl);
          commit('setPromotionalImgsUrls', data.responseData.promoImgs);
        }
        else {
          throw new Error('Error retrieving initial content');
        }
      } catch (err) {
        console.log('Error', err);
        throw err;
      }
    },

    async getPrivacyPol({ commit }, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          url: ProxyUrls.privacyPolicy,
          method: 'get',
        });

        if (data && data.httpStatus === 200) {
          commit('setPrivacyPol', data.responseData.privacyPolicy);
        }
        else {
          throw new Error('result error getting privacy policy');
        }
      } catch (err) {
        console.log('Error', err);
        throw err;
      }
    },

    async getTermsAndConditions({ commit }, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          url: ProxyUrls.termsAndConditions,
          method: 'get',
        });

        if (data && data.httpStatus === 200) {
          commit('setTermsAndConditions', data.responseData.termsConditions);
        }
        else {
          throw new Error('result error getting terms and conditions');
        }
      } catch (err) {
        console.log('Error', err);
        throw err;
      }
    },

    async getContactData({ commit }, payload) {
      try {
        const { data } = await Vue.prototype.$axios({
          url: ProxyUrls.getContactData,
          method: 'get',
        });

        if (data && data.httpStatus === 200) {
          commit('setContactData', data.responseData.details_html);
        }
        else {
          throw new Error('result error getting contact data');
        }
      } catch (err) {
        console.log('Error', err);
        throw err;
      }
    },
  },

  getters: {
    socialMediaData(state) {
      return state.socialMedia;
    },

    brandingData(state) {
      return state.brandingData;
    },

    loginImgUrl(state) {
      return state.loginImgUrl;
    },

    promotionalImgsUrls(state) {
      return state.promotionalImgsUrls;
    },

    lastUpdateData(state) {
      return state.lastUpdate;
    },

    privacyPolData(state) {
      return state.privacyPolicy;
    },

    termsConditionsData(state) {
      return state.termsAndConditions;
    },

    contactData(state) {
      return state.contactData;
    }
  }
};
